import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {provideHttpClient} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {provideDbcrIcons} from '@db/db-core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: "./assets/i18n/",
        suffix: ".json",
        enforceLoading: true,    // Adds cache-busting timestamp
        useHttpBackend: true
      }),
    }),
    AppComponent
  ],
  providers: [
    provideHttpClient(),
    provideDbcrIcons()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
